import { render } from "./BackToBoard.vue?vue&type=template&id=767257f4"
import script from "./BackToBoard.vue?vue&type=script&lang=js"
export * from "./BackToBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__